import React from 'react';
import './FormLogin.scss';
import Button from 'Components/Shared/Button/Button';
import InputField from 'Components/Shared/InputField/InputField';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { LoginView } from 'Store/User/reducer';
import Spinner from 'Components/Shared/Spinner/Spinner';

interface IProps {
  isFetching: boolean;
  loginView: LoginView;
  currentInput: Julius.Website.CustomerLoginViewModel;
  showCreateOption: boolean;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onCreateAccount: () => void;
  onForgotPassword: () => void;
  onSendNewPassword: () => void;
}

const FormLogin: React.SFC<IProps> = ({
  isFetching,
  loginView,
  currentInput: {
    email,
    password,
  },
  showCreateOption,
  onChange,
  onSubmit,
  onCreateAccount,
  onForgotPassword,
  onSendNewPassword,
}) => {

  const FormattedHeader = () => (
    showCreateOption ?
    <>
      <FormattedText 
        style='title'
        displayName='Logga in'
        formattedName='login.login.header'
      />
      <FormattedText 
        style='sub-title'
        displayName='Logga in och få tillgång till dina bokningar online.'
        formattedName='login.login.text'
      />
    </> :
    <>
      <FormattedText 
        style='title'
        displayName='Köpt biljett hos oss tidigare?'
        formattedName='login.revisit.header'
      />
      <FormattedText 
        style='sub-title'
        displayName='Logga in för att underlätta ditt köp och få tillgång till dina bokningar online.'
        formattedName='login.revisit.text'
      />
    </>
  );

  const wrapperStyle = showCreateOption  ? 'form-login full' : 'form-login small';

  if (isFetching) {
    return (
      <div className={ wrapperStyle }>
        <FormattedHeader />
        <Spinner />
      </div>
    );
  }

  let forgotText;

  switch (loginView) {
    case LoginView.FORGOT_MESSAGE:
      forgotText = (
        <div className='forgot-message'>
          <FormattedText
            displayName='Kontrollera att du fyllt i din e-postadress korrekt så skickar vi ett nytt lösenord.'
            formattedName='login.forgot.text'
          />&nbsp;
          <FormattedText 
            style='send-button' 
            displayName='Skicka'
            formattedName='global.send'
            onClick={ onSendNewPassword }
          />
        </div>
      );
      break;
    case LoginView.NEW_PASSWORD_SENT:
      forgotText = (
        <div className='forgot-message'>
          <FormattedText
            displayName='Ett nytt lösenord har skickats till din e-post.'
            formattedName='login.forgot.success'
          />
        </div>
      );
      break;
    case LoginView.NEW_PASSWORD_FAILED:
      forgotText = (
        <div className='forgot-message'>
          <FormattedText
            displayName='Det gick inte att skicka ett nytt lösenord. Försök igen? '
            formattedName='login.forgot.failed'
          />
          <FormattedText 
            displayName='Skicka'
            formattedName='global.send'
            onClick={ onSendNewPassword } 
          />
        </div>
      );
      break;
    default:
      forgotText = (
        <div className='button-forgot' onClick={ onForgotPassword }>
          <FormattedText
            displayName='Glömt lösenord?'
            formattedName='login.forgot.header'
          />
        </div>
      );
  }

  return (
    <div className={ wrapperStyle }>
      <FormattedHeader />
      <form onSubmit={ onSubmit }>
        <InputField 
          type='email' 
          name='email' 
          value={ email }
          onChange={ onChange } 
          label={ {
            displayName: 'E-post',
            formattedName: 'global.email',
          } }
          required={ true }
        />
        <InputField 
          type='password' 
          name='password' 
          value={ password }
          onChange={ onChange } 
          label={ {
            displayName: 'Lösenord',
            formattedName: 'global.password',
          } }
          required={ true }
        />
        <div className='button-container'>
          { loginView === LoginView.LOGIN_FAILED &&
            <FormattedText 
              style='error' 
              displayName='Felaktigt användarnamn eller lösenord'
              formattedName='login.failure'
            />
          }
          <Button type='submit'>
            <FormattedText
              displayName='Logga in'
              formattedName='login.login.header'
            />
          </Button>
        </div> 
      </form>
      { showCreateOption &&
        <Button color='purple' onClick={ onCreateAccount }>
          <FormattedText
            displayName='Skapa konto'
            formattedName='account.create.header'
          />
        </Button>
      }
      { forgotText }
    </div>
  );
};

export default FormLogin;


// WEBPACK FOOTER //
// ./src/components/FormLogin/FormLogin.tsx